// React
import { useEffect, useMemo, useState } from "react"
import { useNavigate } from "react-router-dom"

// Hooks and Redux
import { useAppSelector } from "../../redux/hooks"

// MUI Components
import { ThemeProvider } from "@mui/material/styles"
import Box from "@mui/material/Box"
import MenuItem from "@mui/material/MenuItem"
import Button from "@mui/material/Button"
import Typography from "@mui/material/Typography"
import Grid from "@mui/material/Grid"
import TextField from "@mui/material/TextField"
import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import Select, { SelectChangeEvent } from "@mui/material/Select"
import Dialog from "@mui/material/Dialog"
import CircularProgress from "@mui/material/CircularProgress"
import DialogTitle from "@mui/material/DialogTitle"
import DialogContent from "@mui/material/DialogContent"
import DialogActions from "@mui/material/DialogActions"

import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers"

// Utils
import newAdapter from "../../utils/newAdapter"
import dayjs, { Dayjs } from "dayjs"
import { useTranslation } from "react-i18next"
import jwtDecode from "jwt-decode"
import { useForm } from "react-hook-form"
import Swal from "sweetalert2"

// Styles
import { green } from "@mui/material/colors"
import theme from "../../styles/theme"

// Services
import {
  // getAllActiveBank,
  // getAllActiveCompany, //เปลี่ยนมาใช้ useAppSelector
  getAllActiveHolidaySchedule,
  getAllActiveIncentiveGroup,
  getAllActivePayGrade,
  getAllActivePayGroup,
  getAllActiveWorkGroup,
  getAllActiveWorkSchedule,
} from "../../services/MasterDataService"
// import { getAllSites } from "../../services/SiteService" //เปลี่ยนมาใช้ useAppSelector
import { createManyECData } from "../../services/ECService"

// Types
import { TokenPayload, Site } from "../../@types"
import match from "autosuggest-highlight/match"
import parse from "autosuggest-highlight/parse"
import { Autocomplete } from "@mui/material"

export interface InputDataToECProps {
  app_form_status_id: string[]
  app_form_Data: any
  keepMounted: boolean
  open: boolean
  onClose: (value?: boolean) => void
}

export default function ApplyMultiToEC(props: InputDataToECProps) {
  const { app_form_status_id, app_form_Data, onClose, open, ...other } = props
  const navigate = useNavigate()
  const { t } = useTranslation()

  const [selectedHireDate, setSelectedHireDate] = useState<Dayjs | null>(
    dayjs()
  )
  const [positionId, setPositionId] = useState<string>("")
  const [selectedCompany, setSelectedCompany] = useState<string>("")
  const [selectedIncentiveGroup, setSelectedIncentiveGroup] = useState<any>("N")
  const [selectedPayGrade, setSelectedPayGrade] = useState<string>("JL1")
  const [selectedWorkSchedule, setSelectedWorkSchedule] = useState<string>("")
  const [selectedHolidaySchedule, setSelectedHolidaySchedule] =
    useState<string>("")
  const [selectedWorkGroup, setSelectedWorkGroup] = useState<string>("")
  const [selectedContractStartDate, setSelectedContractStartDate] =
    useState<Dayjs | null>(null)
  const [selectedContractEndDate, setSelectedContractEndDate] =
    useState<Dayjs | null>(null)
  const [selectedBank, setSelectedBank] = useState<string>("")
  const [bankAccountNumber, setBankAccountNumber] = useState<string>("")
  const [selectedPayGroup, setSelectedPayGroup] = useState<string>("")
  // const [selectedJobs, setSelectedJobs] = useState<string>('');
  const [selectedConfirmJobs, setSelectedConfirmJobs] =
    useState<string>("false")

  const [Amount101, setAmount101] = useState<string>("")
  const [Amount102, setAmount102] = useState<string>("")
  const [Amount103_1, setAmount103_1] = useState<string>("")
  const [Amount125, setAmount125] = useState<string>("")
  const [Amount128, setAmount128] = useState<string>("")
  const [Amount133, setAmount133] = useState<string>("")
  const [Amount163, setAmount163] = useState<string>("")
  const [isLoading, setIsLoading] = useState<boolean>(false)

  interface PersonData {
    id: string | number
    id_card_number?: string
    name: string
    bank_account_number: string
    bank: string
  }

  // เปลี่ยนมาใช้ useAppSelector
  // const [companyList, setCompanyList] = useState<
  //   { company_code: string; company_name: string }[]
  // >([])
  const { companies: companyList, sites: masterSites } = useAppSelector(
    (state) => state.masterData
  )
  const [payGradeList, setPayGradeList] = useState<
    { external_code: string; label: string }[]
  >([])
  const [incentiveGroupList, setIncentiveGroupList] = useState<
    { external_code: string; label: string }[]
  >([])
  const [workScheduleList, setWorkScheduleList] = useState<
    { external_code: string; label: string }[]
  >([])
  const [holidayScheduleList, setHolidayScheduleList] = useState<
    { external_code: string; label: string }[]
  >([])
  const [workGroupList, setWorkGroupList] = useState<
    { external_code: string; label: string }[]
  >([])
  // const [BankList, setBankList] = useState<
  //   { bank_code: string; bank_name: string }[]
  // >([])
  const [payGroupList, setPayGroupList] = useState<
    { pay_group_id: string; label: string }[]
  >([])

  const [submittedLoading, setSubmittedLoading] = useState<boolean>(false)
  const [jobREmail, setjobREmail] = useState<string>(
    app_form_Data[0]?.job_relationship_email
  )
  // เปลี่ยนมาใช้ useAppSelector
  // const [siteData, setSiteData] = useState<
  //   Pick<Site, "site_id" | "site_name">[]
  // >([])
  const siteData = useMemo(
    () =>
      [...masterSites]
        .sort((a: Site, b: Site) => a.site_id.localeCompare(b.site_id))
        .filter((site: Site) => site.is_active === true),
    [masterSites]
  )
  const [selectedSite, setSelectedSite] = useState<string>("") //app_form_Data.Job.Site.site_id
  const [selectedSiteOption, setSelectedSiteOption] = useState<{
    site_id: string
    site_name: string
  } | null>(null)
  const emailRegex = /^[a-zA-Z0-9._-]+@betagro\.com$/
  // const confirmJobs: ConfirmJob[] = [
  //   {
  //     title: "text_confirmJob",
  //     value: "true",
  //   },
  //   {
  //     title: "text_not_confirmJob",
  //     value: "false",
  //   },
  // ]

  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm()

  useEffect(() => {
    // เปลี่ยนมาใช้ useAppSelector
    // const fetchAllActiveCompany = async () => {
    //   try {
    //     const response = await getAllActiveCompany(true)

    //     if (response.data?.success) {
    //       setCompanyList(response?.data?.companies)
    //     }
    //   } catch (error) {
    //     console.log(error)
    //     navigate("/servererror", { replace: true })
    //   }
    // }

    const fetchAllActiveIncentiveGroup = async () => {
      try {
        const response = await getAllActiveIncentiveGroup("Active")

        if (response.data?.success) {
          setIncentiveGroupList(response?.data?.incentiveGroups)
        }
      } catch (error) {
        console.log(error)
        navigate("/servererror", { replace: true })
      }
    }

    const fetchAllActivePayGrade = async () => {
      try {
        const response = await getAllActivePayGrade("Active")

        if (response.data?.success) {
          setPayGradeList(response?.data?.payGrades)
        }
      } catch (error) {
        console.log(error)
        navigate("/servererror", { replace: true })
      }
    }

    const fetchAllActiveWorkSchedule = async () => {
      try {
        const response = await getAllActiveWorkSchedule("Active")

        if (response.data?.success) {
          setWorkScheduleList(response?.data?.workSchedules)
        }
      } catch (error) {
        console.log(error)
        navigate("/servererror", { replace: true })
      }
    }

    const fetchAllActiveHolidaySchedule = async () => {
      try {
        const response = await getAllActiveHolidaySchedule("Active")

        if (response.data?.success) {
          setHolidayScheduleList(response?.data?.holidaySchedules)
        }
      } catch (error) {
        console.log(error)
        navigate("/servererror", { replace: true })
      }
    }

    const fetchAllActiveWorkGroup = async () => {
      try {
        const response = await getAllActiveWorkGroup("Active")

        if (response.data?.success) {
          setWorkGroupList(response?.data?.workGroups)
        }
      } catch (error) {
        console.log(error)
        navigate("/servererror", { replace: true })
      }
    }

    // const fetchAllActiveBank = async () => {
    //   try {
    //     const response = await getAllActiveBank()

    //     if (response.data?.success) {
    //       setBankList(response?.data?.banks)
    //     }
    //   } catch (error) {
    //     console.log(error)
    //     navigate("/servererror", { replace: true })
    //   }
    // }

    const fetchAllActivePayGroup = async () => {
      try {
        const response = await getAllActivePayGroup("Active")

        if (response.data?.success) {
          setPayGroupList(response?.data?.payGroups)
        }
      } catch (error) {
        console.log(error)
        navigate("/servererror", { replace: true })
      }
    }

    // เปลี่ยนมาใช้ useAppSelector
    // const fetchSites = async () => {
    //   try {
    //     const response = await getAllSites()
    //     if (response.data?.success) {
    //       const sitesData = response?.data?.sites
    //       const dataSort = sitesData.sort((a: Site, b: Site) =>
    //         a.site_id.localeCompare(b.site_id)
    //       )
    //       setSiteData(dataSort.filter((site: Site) => site.is_active === true))
    //     }
    //   } catch (error) {
    //     navigate("/servererror", { replace: true })
    //   }
    // }

    if (open) {
      // fetchSites() //เปลี่ยนมาใช้ useAppSelector
      // fetchAllActiveCompany() //เปลี่ยนมาใช้ useAppSelector
      fetchAllActiveIncentiveGroup()
      fetchAllActivePayGrade()
      fetchAllActiveWorkSchedule()
      fetchAllActiveHolidaySchedule()
      fetchAllActiveWorkGroup()
      fetchAllActivePayGroup()
      // fetchAllActiveBank()
      // fetchJobs();
      if (app_form_Data && app_form_Data[0] && app_form_Data[0]?.site_id) {
        setSelectedSite(app_form_Data[0]?.site_id)
      }
    }
  }, [navigate, open])

  const removeIdCardNumber = (
    dataArray: PersonData[]
  ): Omit<PersonData, "id_card_number">[] => {
    return dataArray.map((item) => {
      const { id_card_number, ...rest } = item
      return rest
    })
  }

  const onSubmitted = async () => {
    const checkEmail = emailRegex.test(jobREmail.toLowerCase())
    const userData = removeIdCardNumber(app_form_Data)

    if (checkEmail && userData) {
      try {
        setSubmittedLoading(true)
        setIsLoading(true)
        const parsedToken: TokenPayload = jwtDecode(localStorage.access_token)
        const ECData = {
          hire_date: dayjs(selectedHireDate).format("DD/MM/YYYY"),
          position_id: positionId,
          company: selectedCompany,
          incentive_group: selectedIncentiveGroup,
          pay_grade: selectedPayGrade,
          work_schedule: selectedWorkSchedule,
          holiday_schedule: selectedHolidaySchedule,
          work_group: selectedWorkGroup,
          contract_start_date: selectedContractStartDate
            ? dayjs(selectedContractStartDate).format("DD/MM/YYYY")
            : null,
          contract_end_date: selectedContractEndDate
            ? dayjs(selectedContractEndDate).format("DD/MM/YYYY")
            : null,
          pay_group: selectedPayGroup,
          amount_101: Amount101,
          amount_102: Amount102,
          amount_103_1: Amount103_1,
          amount_125: Amount125,
          amount_128: Amount128,
          amount_133: Amount133,
          amount_163: Amount163,
          created_by: parsedToken.Username,
          job_relationship_email: jobREmail,
          site_id: selectedSite,
        }
        const response = await createManyECData({ ecData: ECData, userData })

        if (
          response?.data &&
          response?.data?.success === true &&
          userData.length === response?.data?.data?.createDataToEC
        ) {
          setSubmittedLoading(false)
          setIsLoading(false)
          onClose(true)

          Swal.fire({
            icon: "success",
            title: `${t("Success")}`,
            text: `${t("Ecsuccess")}`,
            confirmButtonText: `${t("ok")}`,
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.reload()
            }
          })
        } else if (
          response?.data &&
          response?.data?.success === true &&
          userData.length !== response?.data?.data?.createDataToEC
        ) {
          setSubmittedLoading(false)
          setIsLoading(false)
          onClose(true)

          Swal.fire({
            icon: "error",
            title: `${t("Error")}`,
            text: `${t("ECSomefailed")}`,
            confirmButtonText: `${t("ok")}`,
          })
        } else {
          setSubmittedLoading(false)
          setIsLoading(false)
          onClose(true)

          Swal.fire({
            icon: "error",
            title: `${t("Error")}`,
            text: `${t("ECfailed")}`,
            confirmButtonText: `${t("ok")}`,
          })
        }
      } catch (error) {
        console.log(error)
        Swal.fire({
          icon: "error",
          title: `${t("Error")}`,
          text: `${t("Please try again")}`,
          confirmButtonText: `${t("ok")}`,
        })
      }
    }
  }

  useEffect(() => {
    setValue("site", selectedSite, { shouldValidate: true })
    setSelectedSiteOption(
      siteData
        .filter((item) => item.site_id === selectedSite)
        .map((site1) => ({
          site_id: site1.site_id,
          site_name: site1.site_name,
        }))[0]
    )
  }, [selectedSite, setValue, siteData])
  useEffect(() => {
    setValue("company", selectedCompany, { shouldValidate: true })
  }, [selectedCompany, setValue])
  useEffect(() => {
    setValue("work_schedule", selectedWorkSchedule, { shouldValidate: true })
  }, [selectedWorkSchedule, setValue])
  useEffect(() => {
    setValue("holiday_schedule", selectedHolidaySchedule, {
      shouldValidate: true,
    })
  }, [selectedHolidaySchedule, setValue])
  useEffect(() => {
    setValue("pay_group", selectedPayGroup, { shouldValidate: true })
  }, [selectedPayGroup, setValue])
  return (
    <ThemeProvider theme={theme}>
      <Dialog
        sx={{ "& .MuiDialog-paper": { width: "100%" } }}
        maxWidth="lg"
        open={open}
        {...other}
      >
        {isLoading && (
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "rgba(255, 255, 255, 0.7)",
              zIndex: 9999,
              borderRadius: "inherit",
            }}
          >
            <CircularProgress color="primary" />
          </Box>
        )}

        <DialogTitle
          id="scroll-dialog-title"
          sx={{ fontWeight: "bold", fontSize: { xs: 16, sm: 18 } }}
        >
          {t("Input other data for applicant")}
        </DialogTitle>
        <DialogContent
          dividers
          sx={{ display: "flex", flexDirection: "column" }}
        >
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <TextField
                  // disabled={selectedConfirmJobs === 'true' ? false : true}
                  fullWidth
                  id="job_relationship_email"
                  label={t("Job Relationship Email") + " *"}
                  placeholder={t("Job Relationship Email")!}
                  {...register("job_relationship_email", {
                    required: selectedConfirmJobs === "true" ? false : true,
                  })}
                  value={jobREmail}
                  onChange={(event) => {
                    setjobREmail(event.target.value)
                    setSelectedConfirmJobs(
                      event.target.value.length > 0 ? "true" : "false"
                    )
                    errors.job_relationship_email = undefined
                  }}
                  // inputProps={{ maxLength: 8 }}
                  error={errors.job_relationship_email ? true : false}
                />
                {selectedConfirmJobs === "true" &&
                  emailRegex.test(jobREmail.toLowerCase()) === false && (
                    <Typography
                      variant="inherit"
                      color="error"
                      align="left"
                      pt={1}
                      ml={1}
                      fontSize={13}
                    >
                      {t(
                        "Accounts can only be created with Betagro email addresses"
                      )}
                    </Typography>
                  )}
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <Autocomplete
                  onChange={(
                    event,
                    newValue: {
                      site_id: string
                      site_name: string
                    } | null
                  ) => {
                    setSelectedSite(newValue?.site_id || "")
                  }}
                  options={siteData}
                  getOptionLabel={(option) =>
                    option.site_id + " - " + option.site_name
                  }
                  value={selectedSiteOption}
                  renderOption={(props, option, { inputValue, selected }) => {
                    const matches = match(
                      option.site_id + " - " + option.site_name,
                      inputValue,
                      {
                        insideWords: true,
                      }
                    )
                    const parts = parse(
                      option.site_id + " - " + option.site_name,
                      matches
                    )

                    return (
                      <li {...props}>
                        <div>
                          {parts.map((part: any, index: any) => (
                            <span
                              key={index}
                              style={{
                                fontWeight: part.highlight ? 700 : 400,
                              }}
                            >
                              {part.text}
                            </span>
                          ))}
                        </div>
                      </li>
                    )
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder={t("Site") + " *"}
                      label={t("Site") + " *"}
                      error={errors.site ? true : false}
                      {...register("site", { required: true })}
                    />
                  )}
                />
              </FormControl>
              {errors.site?.type === "required" && (
                <Typography
                  variant="inherit"
                  color="error"
                  align="left"
                  pt={1}
                  ml={1}
                  fontSize={13}
                >
                  {t("Site is required")}
                </Typography>
              )}
            </Grid>
            <Grid item xs={12} sm={12}>
              <LocalizationProvider dateAdapter={newAdapter} adapterLocale="th">
                <MobileDatePicker
                  sx={{ width: "100%" }}
                  label={t("Hire Date") + " *"}
                  format="DD/MM/YYYY"
                  {...register("hire_date", { required: true })}
                  closeOnSelect
                  localeText={{
                    okButtonLabel: `${t("ok")}`,
                    cancelButtonLabel: `${t("Cancel")}`,
                  }}
                  value={selectedHireDate}
                  dayOfWeekFormatter={(_day, weekday) =>
                    `${weekday.format("dd")}.`
                  }
                  onChange={(newValue) => {
                    try {
                      if (newValue !== null) {
                        setSelectedHireDate(dayjs(newValue))
                      }
                    } catch (error) {}
                  }}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                id="position_id"
                label={t("No. position") + " *"}
                placeholder={t("No. position")!}
                {...register("position_id", {
                  required: true,
                  maxLength: 8,
                  minLength: 8,
                })}
                value={positionId}
                onChange={(event) => {
                  setPositionId(event.target.value)
                  errors.position_id = undefined
                }}
                inputProps={{ maxLength: 8 }}
                error={errors.position_id ? true : false}
              />
              {errors.position_id?.type === "required" && (
                <Typography
                  variant="inherit"
                  color="error"
                  align="left"
                  pt={1}
                  ml={1}
                  fontSize={13}
                >
                  {t("No. position is required")}
                </Typography>
              )}
              {errors.position_id?.type === "maxLength" && (
                <Typography
                  variant="inherit"
                  color="error"
                  align="left"
                  pt={1}
                  ml={1}
                  fontSize={13}
                >
                  {t("No. position must be at least 8 characters")}
                </Typography>
              )}
              {errors.position_id?.type === "minLength" && (
                <Typography
                  variant="inherit"
                  color="error"
                  align="left"
                  pt={1}
                  ml={1}
                  fontSize={13}
                >
                  {t("No. position must be at least 8 characters")}
                </Typography>
              )}
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <Autocomplete
                  onChange={(
                    event,
                    newValue: {
                      company_code: string
                      company_name: string
                    } | null
                  ) => {
                    setSelectedCompany(newValue?.company_code || "")
                  }}
                  options={companyList}
                  getOptionLabel={(option) =>
                    option.company_code + " - " + option.company_name
                  }
                  value={
                    companyList.filter(
                      (item) => item.company_code === selectedCompany
                    )[0]
                  }
                  renderOption={(props, option, { inputValue, selected }) => {
                    const matches = match(
                      option.company_code + " - " + option.company_name,
                      inputValue,
                      {
                        insideWords: true,
                      }
                    )
                    const parts = parse(
                      option.company_code + " - " + option.company_name,
                      matches
                    )

                    return (
                      <li {...props}>
                        <div>
                          {parts.map((part: any, index: any) => (
                            <span
                              key={index}
                              style={{
                                fontWeight: part.highlight ? 700 : 400,
                              }}
                            >
                              {part.text}
                            </span>
                          ))}
                        </div>
                      </li>
                    )
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder={t("Company") + " *"}
                      label={t("Company") + " *"}
                      error={errors.company ? true : false}
                      {...register("company", { required: true })}
                    />
                  )}
                />
              </FormControl>
              {errors.company?.type === "required" && (
                <Typography
                  variant="inherit"
                  color="error"
                  align="left"
                  pt={1}
                  ml={1}
                  fontSize={13}
                >
                  {t("Company is require")}
                </Typography>
              )}
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel
                  id="incentiveGroup"
                  error={errors.incentive_group ? true : false}
                >
                  {t("Incentive Group") + " *"}
                </InputLabel>
                <Select
                  error={errors.incentive_group ? true : false}
                  required
                  labelId="incentiveGroup"
                  id="incentiveGroup"
                  label={t("Incentive Group") + " *"}
                  {...register("incentive_group", { required: true })}
                  value={selectedIncentiveGroup}
                  onChange={(event: SelectChangeEvent) => {
                    setSelectedIncentiveGroup(event.target.value as string)
                    errors.incentive_group = undefined
                  }}
                >
                  {incentiveGroupList.length > 0 &&
                    incentiveGroupList.map(
                      (item: { external_code: string; label: string }) => {
                        return (
                          <MenuItem
                            key={item.external_code}
                            value={item.external_code}
                            selected={true}
                          >
                            {item.label}
                          </MenuItem>
                        )
                      }
                    )}
                </Select>
              </FormControl>
              {errors.incentive_group?.type === "required" && (
                <Typography
                  variant="inherit"
                  color="error"
                  align="left"
                  pt={1}
                  ml={1}
                  fontSize={13}
                >
                  {t("Incentive Group is required")}
                </Typography>
              )}
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <Autocomplete
                  onChange={(
                    event,
                    newValue: {
                      external_code: string
                      label: string
                    } | null
                  ) => {
                    setSelectedWorkSchedule(newValue?.external_code || "")
                  }}
                  options={workScheduleList}
                  getOptionLabel={(option) => option.label}
                  value={
                    workScheduleList.filter(
                      (item) => item.external_code === selectedWorkSchedule
                    )[0]
                  }
                  renderOption={(props, option, { inputValue, selected }) => {
                    const matches = match(option.label, inputValue, {
                      insideWords: true,
                    })
                    const parts = parse(option.label, matches)

                    return (
                      <li {...props}>
                        <div>
                          {parts.map((part: any, index: any) => (
                            <span
                              key={index}
                              style={{
                                fontWeight: part.highlight ? 700 : 400,
                              }}
                            >
                              {part.text}
                            </span>
                          ))}
                        </div>
                      </li>
                    )
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder={t("Work Schedule") + " *"}
                      label={t("Work Schedule") + " *"}
                      error={errors.work_schedule ? true : false}
                      {...register("work_schedule", { required: true })}
                    />
                  )}
                />
              </FormControl>
              {errors.work_schedule?.type === "required" && (
                <Typography
                  variant="inherit"
                  color="error"
                  align="left"
                  pt={1}
                  ml={1}
                  fontSize={13}
                >
                  {t("Work Schedule is required")}
                </Typography>
              )}
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <Autocomplete
                  onChange={(
                    event,
                    newValue: {
                      external_code: string
                      label: string
                    } | null
                  ) => {
                    setSelectedHolidaySchedule(newValue?.external_code || "")
                  }}
                  options={holidayScheduleList}
                  getOptionLabel={(option) => option.label}
                  value={
                    holidayScheduleList.filter(
                      (item) => item.external_code === selectedHolidaySchedule
                    )[0]
                  }
                  renderOption={(props, option, { inputValue, selected }) => {
                    const matches = match(option.label, inputValue, {
                      insideWords: true,
                    })
                    const parts = parse(option.label, matches)

                    return (
                      <li {...props}>
                        <div>
                          {parts.map((part: any, index: any) => (
                            <span
                              key={index}
                              style={{
                                fontWeight: part.highlight ? 700 : 400,
                              }}
                            >
                              {part.text}
                            </span>
                          ))}
                        </div>
                      </li>
                    )
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder={t("Holiday Schedule") + " *"}
                      label={t("Holiday Schedule") + " *"}
                      error={errors.holiday_schedule ? true : false}
                      {...register("holiday_schedule", { required: true })}
                    />
                  )}
                />
              </FormControl>
              {errors.holiday_schedule?.type === "required" && (
                <Typography
                  variant="inherit"
                  color="error"
                  align="left"
                  pt={1}
                  ml={1}
                  fontSize={13}
                >
                  {t("Holiday Schedule is required")}
                </Typography>
              )}
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel
                  id="workGroup"
                  error={errors.work_group ? true : false}
                >
                  {t("Work Group") + " *"}
                </InputLabel>
                <Select
                  error={errors.work_group ? true : false}
                  required
                  labelId="workGroup"
                  id="workGroup"
                  label={t("Work Group") + " *"}
                  {...register("work_group", { required: true })}
                  value={selectedWorkGroup}
                  onChange={(event: SelectChangeEvent) => {
                    setSelectedWorkGroup(event.target.value as string)
                    errors.work_group = undefined
                  }}
                  MenuProps={{ sx: { maxHeight: 500 } }}
                >
                  {workGroupList.length > 0 &&
                    workGroupList.map(
                      (item: { external_code: string; label: string }) => {
                        return (
                          <MenuItem
                            key={item.external_code}
                            value={item.external_code}
                          >
                            {item.label}
                          </MenuItem>
                        )
                      }
                    )}
                </Select>
              </FormControl>
              {errors.work_group?.type === "required" && (
                <Typography
                  variant="inherit"
                  color="error"
                  align="left"
                  pt={1}
                  ml={1}
                  fontSize={13}
                >
                  {t("Work Group is required")}
                </Typography>
              )}
            </Grid>
            <Grid item xs={12} sm={6}>
              <LocalizationProvider dateAdapter={newAdapter} adapterLocale="th">
                <MobileDatePicker
                  sx={{ width: "100%" }}
                  label={t("Contract Start Date")}
                  format="DD/MM/YYYY"
                  closeOnSelect
                  {...register("contract_start_date")}
                  localeText={{
                    okButtonLabel: `${t("ok")}`,
                    cancelButtonLabel: `${t("Cancel")}`,
                    clearButtonLabel: `${t("Clear")}`,
                  }}
                  value={selectedContractStartDate}
                  dayOfWeekFormatter={(_day, weekday) =>
                    `${weekday.format("dd")}.`
                  }
                  onChange={(newValue) => {
                    try {
                      if (newValue !== null) {
                        setSelectedContractStartDate(dayjs(newValue))
                        // setSelectedHireDate(dayjs(newValue));
                      } else {
                        setSelectedContractStartDate(null)
                      }
                    } catch (error) {}
                  }}
                  slotProps={{
                    actionBar: {
                      actions: ["clear", "cancel", "accept"],
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={6}>
              <LocalizationProvider dateAdapter={newAdapter} adapterLocale="th">
                <MobileDatePicker
                  sx={{ width: "100%" }}
                  label={t("Contract End Date")}
                  format="DD/MM/YYYY"
                  {...register("contract_end_date")}
                  closeOnSelect
                  localeText={{
                    okButtonLabel: `${t("ok")}`,
                    cancelButtonLabel: `${t("Cancel")}`,
                    clearButtonLabel: `${t("Clear")}`,
                  }}
                  value={selectedContractEndDate}
                  dayOfWeekFormatter={(_day, weekday) =>
                    `${weekday.format("dd")}.`
                  }
                  onChange={(newValue) => {
                    try {
                      if (newValue !== null) {
                        setSelectedContractEndDate(dayjs(newValue))
                      } else {
                        setSelectedContractEndDate(null)
                      }
                    } catch (error) {}
                  }}
                  slotProps={{
                    actionBar: {
                      actions: ["clear", "cancel", "accept"],
                    },
                  }}
                  minDate={
                    selectedContractStartDate
                      ? selectedContractStartDate
                      : dayjs()
                  }
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <Autocomplete
                  onChange={(
                    event,
                    newValue: {
                      pay_group_id: string
                      label: string
                    } | null
                  ) => {
                    setSelectedPayGroup(newValue?.pay_group_id || "")
                  }}
                  options={payGroupList}
                  getOptionLabel={(option) => option.label}
                  value={
                    payGroupList.filter(
                      (item) => item.pay_group_id === selectedPayGroup
                    )[0]
                  }
                  renderOption={(props, option, { inputValue, selected }) => {
                    const matches = match(option.label, inputValue, {
                      insideWords: true,
                    })
                    const parts = parse(option.label, matches)

                    return (
                      <li {...props}>
                        <div>
                          {parts.map((part: any, index: any) => (
                            <span
                              key={index}
                              style={{
                                fontWeight: part.highlight ? 700 : 400,
                              }}
                            >
                              {part.text}
                            </span>
                          ))}
                        </div>
                      </li>
                    )
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder={t("Pay Group") + " *"}
                      label={t("Pay Group") + " *"}
                      error={errors.pay_group ? true : false}
                      {...register("pay_group", { required: true })}
                    />
                  )}
                />
              </FormControl>
              {errors.pay_group?.type === "required" && (
                <Typography
                  variant="inherit"
                  color="error"
                  align="left"
                  pt={1}
                  ml={1}
                  fontSize={13}
                >
                  {t("Pay Group is required")}
                </Typography>
              )}
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                id="amount_101"
                label={t("101_Amount")}
                placeholder={t("101_Amount")!}
                value={Amount101}
                InputProps={{
                  type: "number",
                  sx: {
                    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                      {
                        display: "none",
                      },
                    "& input[type=number]": {
                      MozAppearance: "textfield",
                    },
                  },
                }}
                onChange={(event) => {
                  setAmount101(event.target.value)
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                id="amount_102"
                label={t("102_Amount")}
                placeholder={t("102_Amount")!}
                value={Amount102}
                InputProps={{
                  type: "number",
                  sx: {
                    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                      {
                        display: "none",
                      },
                    "& input[type=number]": {
                      MozAppearance: "textfield",
                    },
                  },
                }}
                onChange={(event) => {
                  setAmount102(event.target.value)
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                id="amount_103"
                label={t("103_Amount")}
                placeholder={t("103_Amount")!}
                value={Amount103_1}
                InputProps={{
                  type: "number",
                  sx: {
                    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                      {
                        display: "none",
                      },
                    "& input[type=number]": {
                      MozAppearance: "textfield",
                    },
                  },
                }}
                onChange={(event) => {
                  setAmount103_1(event.target.value)
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                id="amount_125"
                label={t("125_Amount")}
                placeholder={t("125_Amount")!}
                value={Amount125}
                InputProps={{
                  type: "number",
                  sx: {
                    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                      {
                        display: "none",
                      },
                    "& input[type=number]": {
                      MozAppearance: "textfield",
                    },
                  },
                }}
                onChange={(event) => {
                  setAmount125(event.target.value)
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                id="amount_128"
                label={t("128_Amount")}
                placeholder={t("128_Amount")!}
                value={Amount128}
                InputProps={{
                  type: "number",
                  sx: {
                    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                      {
                        display: "none",
                      },
                    "& input[type=number]": {
                      MozAppearance: "textfield",
                    },
                  },
                }}
                onChange={(event) => {
                  setAmount128(event.target.value)
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                id="amount_133"
                label={t("133_Amount")}
                placeholder={t("133_Amount")!}
                value={Amount133}
                InputProps={{
                  type: "number",
                  sx: {
                    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                      {
                        display: "none",
                      },
                    "& input[type=number]": {
                      MozAppearance: "textfield",
                    },
                  },
                }}
                onChange={(event) => {
                  setAmount133(event.target.value)
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                id="amount_163"
                label={t("163_Amount")}
                placeholder={t("163_Amount")!}
                value={Amount163}
                InputProps={{
                  type: "number",
                  sx: {
                    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                      {
                        display: "none",
                      },
                    "& input[type=number]": {
                      MozAppearance: "textfield",
                    },
                  },
                }}
                onChange={(event) => {
                  setAmount163(event.target.value)
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            px: 3,
            py: 2,
          }}
        >
          <Box sx={{ display: "flex", gap: 1 }}>
            <Button
              color="error"
              variant="contained"
              onClick={() => {
                onClose()
              }}
              sx={{ px: 3 }}
            >
              {t("Cancel")}
            </Button>
            <Button
              color="error"
              onClick={() => {
                setPositionId("")
                setSelectedCompany("")
                setSelectedIncentiveGroup("N")
                setSelectedPayGrade("JL1")
                setSelectedWorkSchedule("")
                setSelectedHolidaySchedule("")
                setSelectedWorkGroup("")
                setSelectedContractStartDate(null)
                setSelectedContractEndDate(null)
                setSelectedBank("")
                setBankAccountNumber("")
                setSelectedPayGroup("")
                setAmount101("")
                setAmount102("")
                setAmount103_1("")
                setAmount125("")
                setAmount128("")
                setAmount133("")
                setAmount163("")
              }}
              sx={{ px: 3 }}
            >
              {t("Clear")}
            </Button>
          </Box>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit(onSubmitted)}
            sx={{ px: 3 }}
            disabled={submittedLoading}
          >
            {t("Confirm")}
            {submittedLoading && (
              <CircularProgress
                size={24}
                sx={{
                  color: green[500],
                  position: "absolute",
                  zIndex: 999,
                }}
              />
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  )
}
